<template>
    <v-app-bar id="headerMenu" app fixed dark :clipped-left="$vuetify.breakpoint.mdAndUp"
        style="background-color:#212121" dense short elevation="45">

        <!--<v-app-bar-nav-icon @click.stop="toggleNavigationDrawer()"></v-app-bar-nav-icon>-->

        <!-- TODO: App bar nav not working -->
        <v-btn class="hidden-sm-and-down" fab dark small @click.stop="toggleNavigationDrawer()">
            <v-icon dark>reorder</v-icon>
        </v-btn>

        <!--<v-spacer></v-spacer>-->

        <v-toolbar-title></v-toolbar-title>

        <!-- Home button -->
        <v-item-group class="hidden-sm-and-down" v-if="brandItem">
            <v-btn dark text rounded style="color:#da8d2b;text-decoration: none;"
                :to="{ name: 'pages', params: { page: brandItem.cod, section: brandItem['section_list'][0]['cod'] } }">
                <v-icon dark>home</v-icon>
                <span style="text-indent: 5px">{{ brandItem.name }}</span>
            </v-btn>
        </v-item-group>

        <v-spacer></v-spacer>

        <v-item-group class="hidden-sm-and-down" v-for="navMenu in navMenus" v-bind:data="navMenu"
            v-bind:key="navMenu.cod">
            <span v-for="page in navMenu['nav_items']" :key="page.cod">
                <!-- CORPUS SUBMENU -->
                <v-menu id="corpus-submenu" v-if="page.cod === 'cod_hj3y7hwvuuajtlkq0ik'" dark open-on-hover rounded
                    offset-y>
                    <template v-slot:activator="{ attrs, on }">
                        <v-btn text rounded style="color:#da8d2b;text-decoration: none;" v-bind="attrs" v-on="on">
                            <v-icon>arrow_right</v-icon>
                            <span>{{ page.name }}</span>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item v-for="section in page['section_list']" :key="section.cod"
                            :to="{ name: 'pages2', params: { page: page['cod'], section: section['cod'], subsection: section['section_list'][0]['cod'] } }"
                            link v-show="section['is_published']">
                            <v-list-item-title
                                v-text="section.name"></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <!-- MENU ITEMS -->
                <v-btn v-if="page.cod != 'cod_hj3y7hwvuuajtlkq0ik'" text rounded
                    style="color:#da8d2b;text-decoration: none;"
                    :to="{ name: 'pages', params: { page: page.cod, section: page['section_list'][0]['cod'] } }">
                    <span>{{ page.name }}</span>
                </v-btn>
            </span>
        </v-item-group>

        <!-- MOBILE MENU -->
        <v-menu class="hidden-md-and-up" offset-y>
            <!-- <v-app-bar-side-icon slot="activator"></v-app-bar-side-icon> -->
            <template v-slot:activator="{ attrs, on }">
                <v-btn fab dark small v-bind="attrs" v-on="on">
                    <v-icon dark>reorder</v-icon>
                </v-btn>
            </template>

            <v-list v-for="navMenu in navMenus" v-bind:data="navMenu" v-bind:key="navMenu.cod"
                style="min-width: 240px;">
                <v-list-item v-if="brandItem"
                    :to="{ name: 'pages', params: { page: brandItem.cod, section: brandItem['section_list'][0]['cod'] } }"
                    link>
                    <v-list-item-icon>
                        <v-icon>cloud</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ brandItem.name }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <template v-if="navMenu['type'] === 'LINK'">
                    <v-list-item v-for="item in getMobileNavItems(navMenu)" :key="item.key" :to="item.to" link>
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import api from '@/restApi'

export default {
    data() {
        return {
            loading: false,
            brandItem: null,
            navMenus: []
        };
    },
    name: 'main-navbar',
    props: {
        transparent: Boolean,
        colorOnScroll: Number,
        type: String,
        position: String
    },
    async created() {
        this.refreshNavigationItems();
    },
    methods: {
        toggleNavigationDrawer(event) {
            this.$emit('clicked', '');
        },
        isCorpusPage(item) {
            return item && item.cod === 'cod_hj3y7hwvuuajtlkq0ik';
        },
        getPublishedSections(item) {
            return item && item.section_list
                ? item.section_list.filter(section => section.is_published !== false)
                : [];
        },
        getFirstPublishedSection(item) {
            const publishedSections = this.getPublishedSections(item);
            return publishedSections[0] || (item && item.section_list ? item.section_list[0] : null);
        },
        getMobileNavItems(navMenu) {
            const mobileItems = [];

            if (!navMenu || navMenu.type !== 'LINK') {
                return mobileItems;
            }

            navMenu.nav_items.forEach(item => {
                if (this.isCorpusPage(item)) {
                    this.getPublishedSections(item).forEach(section => {
                        const subsection = this.getFirstPublishedSection(section);

                        if (!subsection) {
                            return;
                        }

                        mobileItems.push({
                            key: item.cod + '-' + section.cod,
                            name: section.name,
                            icon: 'pie',
                            to: {
                                name: 'pages2',
                                params: {
                                    page: item.cod,
                                    section: section.cod,
                                    subsection: subsection.cod
                                }
                            }
                        });
                    });
                    return;
                }

                const section = this.getFirstPublishedSection(item);

                if (!section) {
                    return;
                }

                mobileItems.push({
                    key: item.cod,
                    name: item.name,
                    icon: 'pie',
                    to: {
                        name: 'pages',
                        params: {
                            page: item.cod,
                            section: section.cod
                        }
                    }
                });
            });

            return mobileItems;
        },
        async refreshNavigationItems() {
            this.loading = true;

            const queryString = "fields=cod,name,description,order&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all sections
            const response = await api.get("page/sections",queryString);

            if (response instanceof Error) {
                this.loading = false;
                // Do not continue
                return;
            }

           let pages = response;

           // Take only pages with sections
            pages = this.$mout.array.filter(pages, function (item) {
                return (item.order >= 0 && item.section_list.length > 0);
            });

            //                console.log(JSON.stringify(pages))

            for (var i = 0; i < pages.length; i++) {
                // Order page sections list
                if (pages[i]["section_list"]) {
                    pages[i]["section_list"] = this.$mout.array.sort(pages[i]["section_list"], function (a, b) {
                        return a.order > b.order;
                    });

                    for (var j = 0; j < pages[i]["section_list"].length; j++) {
                        if (pages[i]["section_list"][j]["section_list"]) {
                            pages[i]["section_list"][j]["section_list"] = this.$mout.array.sort(pages[i]["section_list"][j]["section_list"], function (a, b) {
                                return a.order > b.order;
                            });
                        }
                    }
                }

                if (pages[i]["name"] === "Inicio") {
                    // Exclude home item
                    this.brandItem = pages[i];
                    continue;
                }

                if (this.navMenus.length > 0 && this.navMenus[this.navMenus.length - 1]["type"] === "LINK") {
                    this.navMenus[this.navMenus.length - 1]["nav_items"].push(pages[i]);
                    continue;
                }

                this.navMenus.push({ type: "LINK", nav_items: [pages[i]] });
            }

            //    console.log(this.navMenus)

            this.loading = false;
        }
    },
    components: {
    }
};
</script>
<style>
.v-app-bar a {
    color: #da8d2b;
}

#headerMenu {
    /*top:148px*/
    height: 48px;
}
</style>
